export default "__VITE_ASSET__BhtHO38C__"